import styled from "@emotion/styled";
export const RadioInput = styled("input")`
    position: absolute;
    inset: 0;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: inherit;
`;
//# sourceMappingURL=RadioInput.js.map